export const ZONE_LABELS = {
  commander: "Commander", partner: "Partner commander", companion: "Companion", main: "Main deck", sideboard: "Sideboard",
  maybeboard: "Maybeboard", planar: "Planar deck", scheme: "Scheme deck", attraction: "Attraction deck",
  contraption: "Contraption deck", vanguard: "Vanguard avatar", tokens: "Tokens", emblems: "Emblems", dungeon: "Dungeons",
};
export const zoneList = (keys, custom = []) =>
  keys.map((k) => ({ key: k, label: ZONE_LABELS[k] || custom.find((c) => c.key === k)?.label || k }));
export const ZONES = zoneList(Object.keys(ZONE_LABELS));
export const FORMAT_OPTIONS = [
  { value: "commander", label: "Commander" },
  { value: "constructed_60", label: "60-card Constructed" },
  { value: "custom", label: "Custom community format" },
];
export const POOL_OPTIONS = [
  { value: "any", label: "Hybrid (custom + official)" },
  { value: "custom_only", label: "Custom cards only" },
  { value: "official_only", label: "Official cards only" },
];
export const KIND_LABEL = { empty: "Empty", custom_only: "Custom-only", official_only: "Official-only", hybrid: "Hybrid" };

export const customToSummary = (c) => ({
  source: "custom", id: c.card_id, name: c.name, mana_cost: c.faces[0]?.mana_cost || "", mana_value: c.mana_value,
  type_line: c.type_line, colors: c.colors, image_url: c.image_url, scheme_subtype: c.scheme_subtype,
});

export const officialToSummary = (c) => ({
  source: "official", id: c.scryfall_id, name: c.name, mana_cost: c.mana_cost, mana_value: c.mana_value,
  type_line: c.type_line, colors: c.colors, image_url: c.image_url, legalities: c.legalities, released_at: c.released_at, set_name: c.set_name,
});

export const toPayload = (entries) => entries.map(({ zone, quantity, source, ref_id, card_back_id }) => ({ zone, quantity, source, ref_id, card_back_id: card_back_id || null }));

export function addEntry(entries, card, zone) {
  const i = entries.findIndex((e) => e.zone === zone && e.source === card.source && e.ref_id === card.id);
  if (i >= 0) return entries.map((e, j) => (j === i ? { ...e, quantity: e.quantity + 1 } : e));
  return [...entries, { zone, quantity: 1, source: card.source, ref_id: card.id, card }];
}
